import $ from 'jquery'
import tippy from 'tippy.js'
import { PluginKey } from '@tiptap/pm/state'
import { getExtensionOption, resolveTippyPortal } from '../utilities'
import { wantsBack } from './bot_object_keys'

const pluginKey = new PluginKey('botObjectSuggestion')

const botObjectTypes = () =>
  [...document.querySelectorAll('.js-bot-object-menu-item-template')].map(
    (template) => ({
      type: template.dataset.type,
      title: template.dataset.title,
    })
  )

const cloneTemplate = (selector) =>
  document.querySelector(selector).content.firstElementChild.cloneNode(true)

const buildTypeMenu = (types) => {
  const menu = cloneTemplate('.js-bot-object-menu-template')
  const ul = menu.querySelector('ul')
  types.forEach(({ type }) => {
    ul.appendChild(
      cloneTemplate(`.js-bot-object-menu-item-template[data-type="${type}"]`)
    )
  })
  return menu
}

const buildPickerPane = (typeInfo, pickerUrl, { onBack }) => {
  const pane = cloneTemplate('.js-bot-object-picker-template')
  const body = pane.querySelector('.js-bot-object-picker-body')
  pane.querySelector('.js-bot-object-picker-title').textContent = typeInfo.title
  pane
    .querySelector('.js-bot-object-picker-back')
    .addEventListener('click', onBack)

  $.ajax({
    url: pickerUrl,
    type: 'GET',
    data: { type: typeInfo.type },
    dataType: 'html',
    success: (html) => {
      body.innerHTML = html
      body.querySelector('input[type="search"]')?.focus()
    },
    error: () => {
      body.textContent = 'Could not load the list. Try again.'
    },
  })

  pane.addEventListener('keydown', (event) => {
    const searchInput = event.target.closest('input')
    if (wantsBack(event, searchInput ? searchInput.value : null)) {
      event.preventDefault()
      event.stopPropagation()
      onBack()
    }
  })

  return pane
}

export default {
  pluginKey,
  char: '@',
  allowedPrefixes: [' ', null],
  items: ({ query }) => {
    const q = query.toLowerCase()
    return botObjectTypes().filter((t) => t.title.toLowerCase().includes(q))
  },
  render: () => {
    let popup
    let container
    let current
    let step = 'types'

    const showTypes = () => {
      step = 'types'
      $(container).off('click', 'li a')
      popup[0].setContent(buildTypeMenu(current.items))
      $(container).on('click', 'li a', (event) => {
        const type = event.currentTarget.closest('li').dataset.botObjectType
        if (type) showPicker(botObjectTypes().find((t) => t.type === type))
      })
    }

    const goBack = () => {
      showTypes()
      current.editor?.commands.focus()
    }

    const showPicker = (typeInfo) => {
      step = 'picker'
      $(container).off('click', 'li a')
      const pickerUrl = getExtensionOption(
        current.editor,
        'botObject',
        'pickerUrl'
      )
      const pane = buildPickerPane(typeInfo, pickerUrl, { onBack: goBack })
      pane.addEventListener('object-picker:pick', (event) => {
        const item = event.detail.items?.[0]
        if (!item) return
        current.command({ gid: item.gid, label: item.internalName })
        popup[0].hide()
      })
      popup[0].setContent(pane)
    }

    return {
      onBeforeStart(obj) {
        current = obj
        container = cloneTemplate(
          '.js-bot-object-suggestions-container-template'
        )
        resolveTippyPortal().append(container)
        popup = tippy('body', {
          getReferenceClientRect: obj.clientRect,
          appendTo: () => container,
          content: buildTypeMenu([]),
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          hideOnClick: true,
          placement: 'bottom-start',
          offset: [10, 0],
          popperOptions: { strategy: 'fixed' },
        })
      },
      onStart(obj) {
        current = obj
        showTypes()
      },
      onUpdate(obj) {
        current = obj
        if (step === 'types') showTypes()
      },
      onKeyDown(props) {
        const key = props.event.key
        if (step === 'picker') {
          if (key !== 'Escape') return false
          goBack()
          return true
        }

        const menuTarget = popup[0].popper.querySelector('.js-bot-object-menu')
        if (key === 'Escape') {
          props.event.cancelBubble = true
          popup[0].hide()
        } else if (key === 'ArrowDown') {
          menuTarget.dispatchEvent(new CustomEvent('menu:arrowDown'))
        } else if (key === 'ArrowUp') {
          menuTarget.dispatchEvent(new CustomEvent('menu:arrowUp'))
        } else if (key === 'Enter' || key === 'Tab') {
          props.event.preventDefault()
          menuTarget.dispatchEvent(new CustomEvent('menu:enterKey'))
        } else {
          return false
        }

        return true
      },
      onExit() {
        popup[0].destroy()
        container.remove()
      },
    }
  },
}
